import { QWERTY, QWERTY_STROKE_OF } from './keyboardGeometry';

/** Typographic characters a passage may carry that no key types — folded to ASCII. */
const ASCII_FOLD = [
    [/[‘’‚′]/g, "'"],
    [/[“”„″]/g, '"'],
    [/[–—−]/g, '-'],
    [/…/g, '...'],
    [/ /g, ' '],
];

export function foldToAscii(text) {
    return ASCII_FOLD.reduce((out, [re, to]) => out.replace(re, to), String(text || ''));
}

const strokeOf = (ch) => QWERTY_STROKE_OF[ch] || null;

export const englishLayout = {
    id: 'english',
    script: 'latin',
    name: 'English (QWERTY)',
    nameBn: 'ইংরেজি (QWERTY)',
    legend: (code) => {
        const pair = QWERTY[code];
        if (!pair) return null;
        // Letters print once (upper case), as on a real keycap.
        if (/^[a-z]$/.test(pair[0])) return { plain: pair[1], shift: null };
        return { plain: pair[0], shift: pair[1] };
    },
    normalizeText: foldToAscii,
    encodeWord(word) {
        return Array.from(foldToAscii(word))
            .map((ch) => {
                const stroke = strokeOf(ch);
                return stroke ? { text: ch, options: [[stroke]] } : null;
            })
            .filter(Boolean);
    },
    render(strokes) {
        return strokes.map((s) => (QWERTY[s.code] ? QWERTY[s.code][s.shift ? 1 : 0] : '')).join('');
    },
    strokeLabel(stroke) {
        if (!stroke) return '';
        if (stroke.code === 'Space') return '␣';
        const pair = QWERTY[stroke.code];
        return pair ? pair[stroke.shift ? 1 : 0] : '';
    },
    /** Which "letter" a stroke counts as in per-key statistics. */
    statKey(stroke) {
        if (!stroke || stroke.code === 'Space') return null;
        const pair = QWERTY[stroke.code];
        if (!pair) return null;
        return /^[a-z]$/.test(pair[0]) ? pair[0] : pair[stroke.shift ? 1 : 0];
    },
};
